import http from './plugin/ajax'
// 头部信息
export const getHeaderList = () => http.post('/cockpit/query') // 查询标题列表
export const getParkingNumber = () => http.post('/sysCarStatistics/parkingNumber') // 查询车位统计
export const getCategory = () => http.get('/cockpit/device/category') // 查询车位统计
export const getUsageStatistics = (data) => http.get(`/cockpit/usageStatistics/${data.type}/${data.year}`) // 查询月度能耗统计分析
export const getelectricity = (data) => http.get(`/cockpit/electricity/${data}`) // 查询月度能耗统计分析
